import uniqWith from 'lodash/uniqWith';

import { createAppSlice } from '@exp/redux/createAppSlice';

import { getBrandContent, getNextStoreModule } from '../../js/common/api';

const initialState = {
  brandContent: null,
  fetchContentPending: false,
  fetchModulePending: false,
  nextStoreModule: null,
  recentContentArticles: null,
};

const noAccessErrorReducer = createAppSlice({
  name: 'noAccessError',
  initialState,
  reducers: (create) => ({
    fetchBrandContent: create.asyncThunk(
      async (orgId) => {
        const res = await getBrandContent(orgId);
        const brandContent = res.data || [];
        const recentContentArticles = uniqWith(
          brandContent
            .reduce((content, { contentArticles, contentFolderId }) => [
              ...content,
              ...contentArticles.map(article => ({
                ...article,
                topicId: contentFolderId,
              }))], [])
            .sort((a, b) => (b.startDate - a.startDate)),
          ({ contentArticleId: aId }, { contentArticleId: bId }) => aId === bId,
        );
        return { brandContent, recentContentArticles };
      },
      {
        pending: (state) => { state.fetchContentPending = true; },
        fulfilled: (state, action) => {
          state.brandContent = action.payload.brandContent;
          state.recentContentArticles = action.payload.recentContentArticles;
          state.fetchContentPending = false;
        },
        rejected: (state) => {
          state.brandContent = [];
          state.recentContentArticles = [];
          state.fetchContentPending = false;
        },
      },
    ),

    fetchNextStoreModule: create.asyncThunk(
      async (storeIds) => {
        const res = await getNextStoreModule(storeIds);
        return { nextStoreModule: res.data };
      },
      {
        pending: (state) => { state.fetchModulePending = true; },
        fulfilled: (state, action) => {
          state.nextStoreModule = action.payload.nextStoreModule;
          state.fetchModulePending = false;
        },
        rejected: (state) => {
          state.nextStoreModule = null;
          state.fetchModulePending = false;
        },
      },
    ),
  }),
});

export const { fetchBrandContent, fetchNextStoreModule } = noAccessErrorReducer.actions;
export default noAccessErrorReducer.reducer;
